import { Injectable ,Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe, DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from './../../Core/Security/security.service';
import { ConfigService } from './../../Core/Abstract/config.service';
import { LogService } from './../../Core/Abstract/log.service';

import { EventsEmitterService } from './../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';
import * as moment from 'moment/moment';
import { GridService } from 'app/Core/Abstract/grid.service';

@Injectable()

export class WelcomeScreenService extends SecurityService{
    @Output() change: EventEmitter<boolean> = new EventEmitter();
    constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService, private datePipe:DatePipe) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    getFields(userId): Observable<any>{
        let serviceUrl = this.baseUrl+'FormDataService/configData?formCd=Welcome_Screen_Form&userId='+'&langId='+this.getActiveLang();
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    loadBean(userId): Observable<any>{
        let serviceUrl = this.baseUrl + 'FormDataService/data?formCd=Welcome_Screen_Form&userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    save(formVal: Object ,id:number): Observable<any>{
        let form = {'dataChar' : JSON.stringify(formVal)}
        let serviceUrl = this.baseUrl + 'FormDataService/data?formCd=Welcome_Screen_Form&userId='+id;
        return this.http.post<any>(serviceUrl,form).pipe(map(response => {return response;}));
    }
    getTerms(onboardingTemplate): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnBoardService/getDocTerms?val='+onboardingTemplate+'&langId='+this.getActiveLang();
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    getTermsFormlyCluster(userId){
        let serviceUrl = this.baseUrl + 'UtilService/getTermsFormlyCluster?regsecId=' + userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    getBuyerCompany(userId){
        let serviceUrl = this.baseUrl + 'OnBoardService/getBuyerCompany?regSecId='+ userId;
        return this.http.get<any>(serviceUrl/* , this.setGetParams(bean) */).pipe(map(super.extractData),catchError(super.handleError));
    }
    validate(formVal: Object ,id:number): Observable<any>{
        let serviceUrl = this.baseUrl + 'welcome/validateOnboardingCustomer?userId='+id+'&crsId=test';
        
        console.log(formVal);
        return this.http.post<any>(serviceUrl,formVal[0]).pipe(map(response => {return response;}));
    }
}
